export default () => {
  return {

    // Inspi Viewer Component
    version: '2.1',
    user: 'inspi',
    token: 'nL@5G8eg',

    // Product
    productLoaded: false,
    productName: null,
    productPrice: null,

    // UI
    menuDisplayed: true,
    dividersDisplayed: true,
    collectionDisplayed: false,

    // Header
    headerAlignment: 'left',
    productNameDisplayed: true,
    productPriceDisplayed: true,

    // Gamepad
    gamepadButtonsColor: '1500AF',
    arButtonDisplayed: true,
    resetButtonDisplayed: true,
    dimensionsButtonDisplayed: true,
    screenshotButtonDisplayed: true,
    projectButtonDisplayed: false,

    // Screenshot
    frontScreenshotEnabled: false,

    // Project
    projectCreating: false,

    // AR
    arLoading: false,

    // Glances
    glancedOptionsItem: null,
  }
}
